import { Button } from 'theme-ui';

import { Svg } from '@snippets';

import { useMenuSidebar } from '../../MenuSidebar';
import { themed } from '../Menu.theme';

export const CtaMenu = themed(({ theme, inputRef, adminLinksColor, ...props }) => {
  const [{ menuSidebar }, { toggleSidebar }] = useMenuSidebar();

  return (
    <Button
      data-comp={CtaMenu.displayName}
      {...props}
      variant="buttons.plain"
      aria-label={menuSidebar ? 'Close menu' : 'Open menu'}
      onClick={toggleSidebar}
      sx={{
        ...props.sx,
        ...theme.cta,
      }}
    >
      {menuSidebar ? (
        <Svg
          alt="Close menu"
          src="/svgs/close.svg#close"
          sx={{ ...theme.cta.icon, color: adminLinksColor }}
          viewBox="0 0 48 48"
        />
      ) : (
        <Svg
          alt="Open menu"
          src="/svgs/cta/menu.svg#menu"
          sx={{ ...theme.cta.icon, color: adminLinksColor }}
          viewBox="0 0 48 48"
        />
      )}
    </Button>
  );
});

CtaMenu.displayName = 'CtaMenu';